import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Label, Input, } from "reactstrap";
import TextField from "../../../common/TextField";
import { toast } from "react-toastify";
import { createCRMLeadCommentService } from "../../../../Services/CRMAdminServices/CRMTaskListService";
import { useQueryClient } from "@tanstack/react-query";

interface SendSmsProps {
    toggle: () => void;
    open: boolean;
    mobileNumber: any;
    leadId?: any;
    staffId?: any;
}

const SendSms: React.FC<SendSmsProps> = ({ toggle, open, mobileNumber, leadId, staffId }) => {
    const [message, setMessage] = useState<string>("");
    const queryClient = useQueryClient();

    const handleSendSms = async () => {
        if (!message.trim()) {
            toast.error("Please enter a message.");
            return;
        }
        const max = message.length > 160 ? "2" : "1";
        const formattedNumber = mobileNumber.replace(/\s/g, "");

        const params = new URLSearchParams({
            username: "Fintrack",
            password: "Fintrack2020",
            to: formattedNumber,
            from: "0402838688",
            message: message,
            ref: "1133546",
            maxsplit: max,
        });

        const baseurl = `https://api.smsbroadcast.com.au/api-adv.php?${params.toString()}`;

        try {
            const response = await fetch(baseurl, {
                method: "GET",
                headers: {
                    "User-Agent": "Mozilla/4.0 (compatible; MSIE 6.0; Windows NT 5.2; .NET CLR 1.0.3705;)",
                },
            });

            if (response.ok) {
                const result = await response.text();
                toast.success("Message Sent!");

                // Save comment as well
                if (leadId && staffId) {
                    try {
                        await createCRMLeadCommentService({
                            leadID: leadId,
                            CommentText: `SMS Sent: ${message}`,
                            Staff: staffId,
                            createdBy: "System",
                        });
                        queryClient.invalidateQueries({ queryKey: ["getCRMLeadCommentService"] });
                    } catch (commentError) {
                        console.error("Error saving SMS comment:", commentError);
                        // We don't want to show an error for the comment if the SMS was already sent successfully,
                        // but maybe a warning?
                    }
                }

                setMessage(""); // Clear message
                toggle(); // Close the modal
            } else {
                toast.error("Failed to send SMS. Please try again.");
            }
        } catch (error) {
            console.error("Error sending SMS:", error);
            toast.error("An error occurred while sending the SMS.");
        }
    };

    return (
        <Modal isOpen={open} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>Send SMS</ModalHeader>
            <ModalBody>
                <Label for="smsMessage" className="fw-bold mt-3">
                    Write your message
                </Label>
                <TextField
                    type="textarea"
                    name="message"
                    value={message}
                    setValue={(name, value) => setMessage(value)}
                    rows={5}
                    maxChars={320}
                />
                <div className="mt-2 text-muted">
                    {message.replace(/\s/g, "").length} characters
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleSendSms}>
                    Send
                </Button>
                <Button color="secondary" onClick={toggle}>
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default SendSms;
